module.exports = __webpack_public_path__ + "static/media/report_struggle.5b920261.svg";